import React from 'react'
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../common/components/form/form.module'



export default function MentorsAccountInfoComponent({ handleInnerFormChange, selectedMentors, gstType, gstRegistrationType }: any) {

    return (
        <>
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Person Account"
                            name="IsPersonAccount"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'Account.IsPersonAccount',
                                    selectedMentors?.Account
                                )
                            }}
                            type="checkbox"
                            value={selectedMentors?.Account?.IsPersonAccount}
                        />





                        <InputContainer
                            label="Name"
                            name="Name"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Account.Name',
                                    selectedMentors?.Account
                                )
                            }}
                            type="text"
                            value={selectedMentors?.Account?.Name}
                        />

                        <InputContainer
                            label="Number Of Employees"
                            name="NumberOfEmployees"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Account.NumberOfEmployees',
                                    selectedMentors?.Account
                                )
                            }}
                            type="number"
                            value={selectedMentors?.Account?.NumberOfEmployees}
                        />


                    




                    </div>
                }
                expandedPanel="userInfo"
                headerTitle="Account Info"
            />

        </>
    )
}